import 'mediaelement/full';

function VideoPlayer() {
  return {
    isPresent: false,
    player: null,
    initializePlayer() {
      this.player = new MediaElementPlayer(this.$el, {
        setDimensions: false,
      });
      this.$nextTick(() => {
        this.player.load();
      });
    },
    destroyPlayer() {
      this.player.remove();
    },
  };
}

export default VideoPlayer;
